<template lang="pug">
input.input-tel(v-model='interface')
</template>
<script>
export default {
  name: 'InputTel',
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      iti: '',
    };
  },
  computed: {
    interface: {
      set(v) {
        this.$emit('input', this.iti.getNumber());
        return v;
      },
      get() {
        return '';
      },
    },
  },
  mounted() {
    const defaultCountry = this.$root.isUSAVersion ? 'us' : 'br';

    this.iti = window.intlTelInput(this.$el, {
      initialCountry: defaultCountry,
      strictMode: true,
      preferredCountries: ['br', 'us', 'es', 'ar', 'uy'],
      autoPlaceholder: 'aggressive',
      separateDialCode: true,
      hiddenInput: () => ({
        phone: 'phone',
      }),
    });
    // if is BR country selected, for use better validation on form
    const emitIsBrazil = () => {
      const { iso2 } = this.iti.getSelectedCountryData();
      this.$emit('is-brazil-changed', iso2 === 'br');
    };
    this.$el.addEventListener('countrychange', () => {
      this.$emit('input', this.iti.getNumber());
      emitIsBrazil();
    });
    emitIsBrazil();
    if (!this.value) {
      return;
    }
    this.iti.setNumber(this.value);
  },
  destroyed() {
    this.$emit('input', this.iti.getNumber());
  },
};
</script>
<style lang="stylus">
.iti
  width: 100%
  .iti__selected-flag
    padding: 0 1em
</style>
